export default {
  name: 'MultiModeDatePickerSelectedPeriod',
  props: {
    previous: {
      type: Boolean,
      default: false
    }
  }
};